// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"228":"9886d57e","433":"73fe4944"}[chunkId] + ".chunk.js");